import React from "react";
import Fade from 'react-reveal/Fade';

import FormationsDatas from "../contents/FormationsDatas";

function Formations (){return (
    <section id='formation'>
      <h2>Mes Formations</h2>
      <div>
    {FormationsDatas.map((formation) => {
        return(
          <Fade clear>
                <div>
                  <h1>{formation.Title}</h1>
                  <p>{formation.School}</p>
                  <p>{formation.Date}</p>
                </div>
          </Fade>
                )}

  )}
      </div>
    </section>
)};

export default Formations;